import React, { useEffect, useMemo, useRef, useState } from 'react';
import SearchableGroupedSelect from '../SearchableGroupedSelect';
import hebergementService from '../../services/hebergementService';

const SiteActivityInlineCell = ({
  siteInfo,
  secteursActiviteGroups = [],
  apiWorking,
  onUpdated,
}) => {
  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [draftValue, setDraftValue] = useState([]);
  const containerRef = useRef(null);

  const currentId = siteInfo.secteurActiviteId
    ? String(siteInfo.secteurActiviteId)
    : (siteInfo.sectionActivitePrincipale ? String(siteInfo.sectionActivitePrincipale) : '');

  const currentLabel = siteInfo.secteurActiviteLabel
    || siteInfo.sectionActiviteLabel
    || null;

  const selectedValues = useMemo(
    () => (currentId ? [currentId] : []),
    [currentId],
  );

  useEffect(() => {
    if (editing) {
      setDraftValue(selectedValues);
    }
  }, [editing, selectedValues]);

  const saveSection = async (values) => {
    if (!apiWorking || saving) return;

    const normalized = values?.[0] ? String(values[0]) : null;
    const current = currentId || null;

    if (normalized === current || (normalized === null && !current)) {
      setEditing(false);
      return;
    }

    setSaving(true);
    try {
      const response = await hebergementService.updateSectionActivite(siteInfo.id, normalized);
      if (response.success && response.data) {
        onUpdated?.(siteInfo.id, response.data);
      }
    } catch (err) {
      console.error('Erreur mise à jour secteur:', err);
    } finally {
      setSaving(false);
      setEditing(false);
    }
  };

  const handleDoubleClick = () => {
    if (!apiWorking || saving) return;
    setEditing(true);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      setEditing(false);
    }
  };

  if (editing) {
    return (
      <div ref={containerRef} onKeyDown={handleKeyDown}>
        <SearchableGroupedSelect
          value={draftValue}
          onChange={(next) => {
            setDraftValue(next);
            saveSection(next);
          }}
          groups={secteursActiviteGroups}
          placeholder="— Choisir un secteur —"
          searchPlaceholder="Rechercher un secteur…"
          multiple={false}
          searchable
          buttonClassName="form-select form-select-sm text-start"
          disabled={saving}
        />
      </div>
    );
  }

  return (
    <div
      role="button"
      tabIndex={0}
      onDoubleClick={handleDoubleClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter') handleDoubleClick();
      }}
      title={apiWorking ? 'Double-cliquer pour modifier' : undefined}
      style={{ cursor: apiWorking ? 'pointer' : 'default', minWidth: '220px' }}
      className={apiWorking ? 'site-activity-cell--editable' : undefined}
    >
      {saving ? (
        <span className="text-muted small">Enregistrement…</span>
      ) : currentLabel ? (
        <span className="badge bg-info-600 text-wrap text-start">{currentLabel}</span>
      ) : (
        <span className="text-muted">—</span>
      )}
      {siteInfo.entrepriseNom && (
        <small className="text-muted d-block">{siteInfo.entrepriseNom}</small>
      )}
    </div>
  );
};

export default SiteActivityInlineCell;
